import Steps from "./cards/Steps";
import human from "../assets/humancharacter.png";
import { FiArrowRight } from "react-icons/fi";

const steps = [
  {
    step: "1",
    title: "Sign Up",
    info: "Create a free Investify account in minutes to get started.",
  },
  {
    step: "2",
    title: "Browse Projects",
    info: "Explore real estate opportunities tailored to your goals.",
  },
  {
    step: "3",
    title: "Make an Investment",
    info: "Buy shares in property projects — for cashflow or resale.",
  },
  {
    step: "4",
    title: "Track Your Earnings",
    info: "Monitor your investments from your personal dashboard.",
  },
  {
    step: "5",
    title: "Get Paid",
    info: "Earn rental income or sell your shares for capital gains.",
  },
];

function HowItWorks() {
  return (
    <div
      className="pb-5 px-3"
      style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}
    >
      {/* Intro Section */}
      <div className="container">
        <div className="row align-items-center py-5">
          <div className="col-lg-6 mb-4 mb-lg-0 text-center text-lg-start">
            <h1
              className="fw-bold"
              style={{
                fontSize: "3rem",
                lineHeight: 1.2,
                marginBottom: "1.5rem",
              }}
            >
              Own Real Estate. One Share at a Time.
            </h1>
            <p
              className="text-muted mt-3"
              style={{ fontSize: "1.1rem", lineHeight: 1.6 }}
            >
              Investify Africa makes real estate investing simple. Buy shares in
              profitable properties and earn passive income through rental
              yields and capital appreciation — all from your dashboard.
            </p>
          </div>
          <div className="col-lg-6 text-center">
            <img
              src={human}
              alt="Investify App"
              className="img-fluid"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </div>
        </div>

        {/* Steps Section */}
        <div className="mt-5">
          <h2
            className="fw-bold text-center mb-5"
            style={{ fontSize: "2.5rem" }}
          >
            The Investment Journey
          </h2>
          <div className="row">
            {steps.map((item) => (
              <div className="col-12 col-md-6 mb-4" key={item.step}>
                <Steps step={item.step} title={item.title} info={item.info} />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container">
        <div
          className="text-center mt-5 p-5 bg-success text-white rounded"
          style={{
            borderRadius: "12px",
            boxShadow: "0 8px 24px rgba(40, 167, 69, 0.2)",
          }}
        >
          <h2 className="fw-bold mb-3" style={{ fontSize: "2rem" }}>
            Ready to Grow Your Wealth Through Real Estate?
          </h2>
          <p className="lead mb-4" style={{ fontSize: "1.1rem" }}>
            Start your investment journey today with Investify. Build
            generational wealth, one share at a time.
          </p>
          <a
            href="https://app.investify.africa/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <button
              className="btn btn-light"
              style={{
                padding: "14px 40px",
                fontSize: "1rem",
                fontWeight: "600",
                borderRadius: "8px",
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                border: "none",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 6px 16px rgba(0, 0, 0, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "none";
              }}
            >
              Get Started Now <FiArrowRight size={18} />
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}

export default HowItWorks;
